import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController, NavParams } from '@ionic/angular';

import { Template } from 'src/models';
import { ApiService } from 'src/services/api.service';
import { AuthService } from 'src/services/auth.service';
import { MessageService } from 'src/services/message.service';

@Component({
  selector: 'app-template-options',
  templateUrl: './template-options.page.html',
  styleUrls: ['./template-options.page.scss'],
})
export class TemplateOptionsPage implements OnInit {
  @ViewChild('nameInput', { static: false }) nameInput;
  callback: (template?: Template) => void;

  isLoading = false;
  isNew = false;
  name: string;
  template: Template;
  isDiscoverable = true;
  isCloning = false;
  communityId: string;

  constructor(
    navParams: NavParams,
    private modalCtrl: ModalController,
    private msgSrvc: MessageService,
    private alertCtrl: AlertController,
    private authService: AuthService,
    private apiService: ApiService,
  ) {
    this.template = navParams.get('template');
    this.isCloning = navParams.get('clone');
    this.communityId = navParams.get('communityId');
    this.callback = navParams.get('callback');
    this.isNew = !this.template.id;
    this.isDiscoverable = !this.communityId;

    if (this.template) {
      this.name = this.isCloning ? `Copy of ${this.template.name}` : this.template.name;
      this.isDiscoverable = this.template.isDiscoverable;
    }
  }

  ngOnInit() {
    setTimeout(() => this.nameInput.setFocus(), 500);
  }

  async save() {
    if (!this.name) {
      this.msgSrvc.show('Choose a name. You can change it later');
      return;
    }

    this.isLoading = true;

    if (!this.isCloning && this.template && this.template.id) {
      const request = this.apiService.put(`/templates/${this.template.id}`, {
        name: this.name,
        isDiscoverable: this.isDiscoverable,
      });

      request.subscribe(
        async (_result) => {
          this.isLoading = false;
          this.template.name = this.name;
          this.template.isDiscoverable = this.isDiscoverable;
          this.callback(this.template);
        },
        async (err) => {
          this.msgSrvc.showError(err);

          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        },
      );
    } else {
      this.template.name = this.name;
      this.template.isDiscoverable = this.isDiscoverable;

      if (this.isCloning) {
        delete this.template.id;
        this.template.tenantId = this.authService.tenantId; // set in case of a sample template cloning
        this.template.communityId = this.communityId;
      }

      this.callback(this.template);
    }
  }

  async delete() {
    const alert = await this.alertCtrl.create({
      header: 'Are you sure?',
      subHeader: 'This cannot be undone.',
      buttons: [
        {
          text: 'Nevermind',
        },
        {
          text: 'Do it',
          handler: async () => {
            this.isLoading = true;

            const request = this.apiService.delete(`/templates/${this.template.id}`);

            request.subscribe(
              async () => {
                this.isLoading = false;
                this.callback();
              },
              async (err) => {
                this.msgSrvc.showError(err);
                this.isLoading = false;
              },
            );
          },
        },
      ],
    });
    alert.present();
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
